export const publishModalAsyncModule = {
  importFn: () => import(/* webpackChunkName: "modals-publish" */ './module-entry'),
  cacheKey: 'modals-publish',
}
